"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pathfinding = _interopRequireDefault(require("./pathfinding.js"));

var _getFloorFromName = _interopRequireDefault(require("./getFloorFromName.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SceneWrapper = function SceneWrapper(_scene, _nodeSize, _nodeColor, handleFlyout, _mode) {
  var _this = this;

  _classCallCheck(this, SceneWrapper);

  this.cameraMove = function (move) {
    var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    // Same handlers for rotation
    var _this$scene = _this.scene,
        camera = _this$scene.camera,
        options = _this$scene.options;
    var _options$upperZoomLim = options.upperZoomLimit,
        upperZoomLimit = _options$upperZoomLim === void 0 ? Infinity : _options$upperZoomLim,
        _options$lowerZoomLim = options.lowerZoomLimit,
        lowerZoomLimit = _options$lowerZoomLim === void 0 ? 0 : _options$lowerZoomLim;

    if (move === 'up') {
      camera.beta -= 0.01 * factor;
      return;
    }

    if (move === 'down') {
      camera.beta += 0.01 * factor;
      return;
    }

    if (move === 'left') {
      camera.alpha -= 0.01 * factor;
      return;
    }

    if (move === 'right') {
      camera.alpha += 0.01 * factor;
      return;
    }

    if (move.includes('pan')) {
      var _camera$getTarget = camera.getTarget(),
          targetX = _camera$getTarget.x,
          targetY = _camera$getTarget.y,
          targetZ = _camera$getTarget.z;

      var _camera$position = camera.position,
          camX = _camera$position.x,
          camZ = _camera$position.z;

      var _camera$position$subt = camera.position.subtract(camera.getTarget()),
          diffX = _camera$position$subt.x,
          diffZ = _camera$position$subt.z;

      var distance = Math.sqrt(Math.pow(targetX - camX, 2) + Math.pow(targetZ - camZ, 2));
      var ratioX = diffX / (distance * 10) * (factor * 2);
      var ratioZ = diffZ / (distance * 10) * (factor * 2);
      var alpha = camera.alpha,
          beta = camera.beta,
          radius = camera.radius;
      var newX;
      var newZ;

      if (move === 'panForward') {
        newX = targetX - ratioX;
        newZ = targetZ - ratioZ;
      }

      if (move === 'panBack') {
        newX = targetX + ratioX;
        newZ = targetZ + ratioZ;
      }

      if (move === 'panLeft') {
        newX = targetX + ratioZ;
        newZ = targetZ - ratioX;
      }

      if (move === 'panRight') {
        newX = targetX - ratioZ;
        newZ = targetZ + ratioX;
      }

      var _camera$panningOrigin = camera.panningOriginTarget,
          centerX = _camera$panningOrigin.x,
          centerZ = _camera$panningOrigin.z;
      var newDistance = Math.sqrt(Math.pow(newX - centerX, 2) + Math.pow(newZ - centerZ, 2));

      if (!camera.panningDistanceLimit || newDistance < camera.panningDistanceLimit) {
        camera.setTarget(new BABYLON.Vector3(newX, targetY, newZ));
        camera.alpha = alpha;
        camera.beta = beta;
        camera.radius = radius;
      }

      return;
    }

    if (camera.mode === BABYLON.Camera.ORTHOGRAPHIC_CAMERA) {
      // Orthographic handlers
      if (move === 'in') {
        _this.orthoScale *= 1 - factor / 10;
        _this.orthoScale = Math.min(Math.max(_this.orthoScale, lowerZoomLimit), upperZoomLimit);
        SceneWrapper.setOrthoCamera(camera, _this.orthoScale);
        return;
      }

      if (move === 'out') {
        _this.orthoScale *= 1 + factor / 10;
        _this.orthoScale = Math.min(Math.max(_this.orthoScale, lowerZoomLimit), upperZoomLimit);
        SceneWrapper.setOrthoCamera(camera, _this.orthoScale);
        return;
      }
    } else {
      // Perspective handlers
      if (move === 'in') {
        camera.radius -= 0.1 * factor;
        return;
      }

      if (move === 'out') {
        camera.radius += 0.1 * factor;
        return;
      }
    }
  };

  this.addMeshToHighlights = function (color, permanent) {
    for (var _len = arguments.length, assetNames = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      assetNames[_key - 2] = arguments[_key];
    }

    if (assetNames.length) {
      assetNames.forEach(function (id) {
        var mesh = _this.scene.getMeshByName(id);

        if (mesh) {
          _this.enableHighlight(mesh, color, permanent);
        }
      });
    }
  };

  this.enableHighlight = function (mesh, color, permanent) {
    _this.tempHighlights.forEach(function (tempMesh) {
      SceneWrapper.disableHighlight(tempMesh);
    });

    if (!mesh.oldMaterial) {
      mesh.oldMaterial = mesh.material;
    }

    _this.highlights = _this.highlights.filter(function (h) {
      return h !== mesh;
    });
    _this.tempHighlights = _this.tempHighlights.filter(function (h) {
      return h !== mesh;
    });

    if (permanent) {
      _this.highlights.push(mesh);
    } else {
      _this.tempHighlights.push(mesh);
    }

    var highLightMaterial = new BABYLON.StandardMaterial("highlight - ".concat(color), _this.scene);
    highLightMaterial.diffuseColor = new BABYLON.Color3.FromHexString(color);
    highLightMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
    mesh.material = highLightMaterial;
  };

  this.createFloorDot = function (position, color) {
    var floorDot = BABYLON.MeshBuilder.CreateSphere('floorDot', {
      diameter: 0.1,
      diameterY: 0.01
    }, _this.scene);
    var dotMaterial = new BABYLON.StandardMaterial('floorDot', _this.scene);
    dotMaterial.diffuseColor = new BABYLON.Color3.FromHexString(color);
    floorDot.position = position;
    floorDot.material = dotMaterial;
    _this.scene.floorDot = floorDot;
  };

  this.createLinkMesh = function (assetName1, assetName2) {
    var scene = _this.scene;
    var mesh1 = scene.getMeshByName(assetName1);
    var mesh2 = scene.getMeshByName(assetName2);

    if (!mesh1 || !mesh2) {
      return null;
    }

    var linkName = "link-".concat(assetName1, "-").concat(assetName2);
    var lowestY = Math.min(mesh1.absolutePosition.y, mesh2.absolutePosition.y);
    var linkMesh = BABYLON.MeshBuilder.CreateTube(linkName, {
      path: [new BABYLON.Vector3(mesh1.absolutePosition.x, lowestY, mesh1.absolutePosition.z), new BABYLON.Vector3(mesh2.absolutePosition.x, lowestY, mesh2.absolutePosition.z)],
      radius: 0.025
    }, scene);
    linkMesh.isPickable = false;
    return linkMesh;
  };

  this.createLink = function () {
    var scene = _this.scene;

    for (var _len2 = arguments.length, assets = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      assets[_key2] = arguments[_key2];
    }

    assets.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
    var asset1 = assets[0],
        asset2 = assets[1];
    var node1 = scene.allNodes.find(function (node) {
      return node.nodeId === asset1.name;
    });
    var node2 = scene.allNodes.find(function (node) {
      return node.nodeId === asset2.name;
    });

    if (!node1 && !node2) {
      return {
        message: 'Cannot link two rooms',
        success: false
      };
    }

    if (node1) {
      if (node1.targetNodes.includes(asset2.name) || node1.targetAssets.includes(asset2.name)) {
        return {
          message: 'Assets already linked',
          success: false
        };
      }

      if (node2) {
        node1.targetNodes.push(node2.nodeId);
      } else {
        var alreadyLinkedNode = _pathfinding["default"].getNodeLinkedToAsset(asset2.name, scene.allNodes);

        if (alreadyLinkedNode) {
          return {
            message: "".concat(asset2.name, " already linked to ").concat(alreadyLinkedNode.nodeId),
            success: false
          };
        }

        node1.targetAssets.push(asset2.name);
      }
    }

    if (node2) {
      if (node2.targetNodes.includes(asset1.name) || node2.targetAssets.includes(asset1.name)) {
        return {
          message: 'Assets already linked',
          success: false
        };
      }

      if (node1) {
        node2.targetNodes.push(node1.nodeId);
      } else {
        var _alreadyLinkedNode = _pathfinding["default"].getNodeLinkedToAsset(asset1.name, scene.allNodes);

        if (_alreadyLinkedNode) {
          return {
            message: "".concat(asset1.name, " already linked to ").concat(_alreadyLinkedNode.nodeId),
            success: false
          };
        }

        node2.targetAssets.push(asset1.name);
      }
    }

    return {
      message: "Created link between ".concat(asset1.name, " and ").concat(asset2.name),
      success: true
    };
  };

  this.removeLink = function () {
    var scene = _this.scene;

    for (var _len3 = arguments.length, assets = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      assets[_key3] = arguments[_key3];
    }

    assets.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
    var asset1 = assets[0],
        asset2 = assets[1];
    var node1 = scene.allNodes.find(function (node) {
      return node.nodeId === asset1.name;
    });
    var node2 = scene.allNodes.find(function (node) {
      return node.nodeId === asset2.name;
    });

    if (node1) {
      node1.targetNodes = node1.targetNodes.filter(function (node) {
        return node !== asset2.name;
      });
      node1.targetAssets = node1.targetAssets.filter(function (asset) {
        return asset !== asset2.name;
      });
    }

    if (node2) {
      node2.targetNodes = node2.targetNodes.filter(function (node) {
        return node !== asset1.name;
      });
      node2.targetAssets = node2.targetAssets.filter(function (asset) {
        return asset !== asset1.name;
      });
    }

    var linkName = "link-".concat(asset1.name, "-").concat(asset2.name);
    var removedLinkMesh = scene.getMeshByName(linkName);

    if (removedLinkMesh) {
      removedLinkMesh.dispose();
    }

    scene.links = scene.links.filter(function (link) {
      return link !== linkName;
    });
  };

  this.removeMeshFromHighlights = function () {
    for (var _len4 = arguments.length, assetNames = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      assetNames[_key4] = arguments[_key4];
    }

    assetNames.map(function (asset) {
      return _this.scene.getMeshByName(asset);
    }).filter(function (mesh) {
      return mesh;
    }).forEach(function (mesh) {
      return SceneWrapper.disableHighlight(mesh);
    });
  };

  this.flyoutScaleFromCamera = function (flyout) {
    var distance = BABYLON.Vector3.Distance(_this.scene.camera.position, flyout.position);
    return 1 + distance / 12 * 0.8;
  };

  this.showLinks = function (asset) {
    var scene = _this.scene;
    var assetNode = scene.allNodes.find(function (node) {
      return node.nodeId === asset.name;
    });

    var linkedNode = _pathfinding["default"].getNodeLinkedToAsset(asset.name, scene.allNodes);

    if (!assetNode && !linkedNode) {
      return;
    }

    var foundNode = scene.allNodes.find(function (node) {
      return node.nodeId === asset.name;
    }) || {
      nodeId: asset.name,
      targetNodes: [_pathfinding["default"].getNodeLinkedToAsset(asset.name, scene.allNodes).nodeId],
      targetAssets: []
    };
    var targets = [].concat(_toConsumableArray(foundNode.targetNodes), _toConsumableArray(foundNode.targetAssets));
    targets.forEach(function (id) {
      var assetList = [id, foundNode.nodeId];
      assetList.sort(function (a, b) {
        return a.localeCompare(b);
      });
      var linkName = "link-".concat(assetList[0], "-").concat(assetList[1]);
      var linkMesh = scene.getMeshByName(linkName);

      if (linkMesh) {
        linkMesh.visibility = 1;
      } else {
        linkMesh = _this.createLinkMesh.apply(_this, assetList);
        scene.links.push(linkName);
      }
    });
    asset.showingLinks = true;
  };

  this.hideLinks = function (asset) {
    var scene = _this.scene;
    var assetLinks = scene.links.filter(function (linkName) {
      return linkName.includes(asset.name);
    });
    assetLinks.forEach(function (linkToHide) {
      var linkMesh = scene.getMeshByName(linkToHide);

      if (linkMesh) {
        linkMesh.dispose();
        scene.links = scene.links.filter(function (linkName) {
          return linkName !== linkToHide;
        });
      }
    });
    asset.showingLinks = false;
  };

  this.moveFloorDot = function (position) {
    if (_this.scene.floorDot) {
      _this.scene.floorDot.position = position;
    }
  };

  this.addNode = function (node) {
    var id = node.id,
        position = node.position,
        _node$targetNodes = node.targetNodes,
        targetNodes = _node$targetNodes === void 0 ? [] : _node$targetNodes,
        _node$targetAssets = node.targetAssets,
        targetAssets = _node$targetAssets === void 0 ? [] : _node$targetAssets,
        floor = node.floor;
    var scene = _this.scene,
        nodeSize = _this.nodeSize,
        mode = _this.mode;

    if (mode === 'development') {
      var nodeMesh = BABYLON.MeshBuilder.CreateSphere(id, {
        diameter: 0.16 * nodeSize,
        slice: 0.5
      }, scene);
      var nodeMaterial = new BABYLON.StandardMaterial('node-material', scene);
      nodeMaterial.diffuseColor = new BABYLON.Color3.FromHexString(_this.nodeColor);
      nodeMesh.material = nodeMaterial;
      nodeMesh.position = position;
    }

    var aNode = {
      nodeId: id,
      position: position,
      targetNodes: targetNodes,
      targetAssets: targetAssets,
      nodeType: 'node',
      floor: floor
    };
    scene.nodeCount = Math.max(scene.nodeCount, parseInt(id.split('-')[1], 10)) + 1;
    scene.allNodes.push(aNode);
  };

  this.addInitialNode = function (node) {
    var id = node.id,
        position = node.position,
        _node$targetNodes2 = node.targetNodes,
        targetNodes = _node$targetNodes2 === void 0 ? [] : _node$targetNodes2,
        _node$targetAssets2 = node.targetAssets,
        targetAssets = _node$targetAssets2 === void 0 ? [] : _node$targetAssets2,
        _node$terminalID = node.terminalID,
        terminalID = _node$terminalID === void 0 ? '' : _node$terminalID,
        _node$orientation = node.orientation,
        orientation = _node$orientation === void 0 ? '' : _node$orientation,
        floor = node.floor;
    var scene = _this.scene,
        nodeSize = _this.nodeSize,
        mode = _this.mode;

    if (mode === 'development') {
      var initialNode = BABYLON.MeshBuilder.CreateSphere(id, {
        diameter: 0.16 * nodeSize,
        slice: 0.5
      }, scene);
      var nodeMaterial = new BABYLON.StandardMaterial('node-material', scene);
      nodeMaterial.diffuseColor = new BABYLON.Color3.FromHexString('#ffff00');
      initialNode.material = nodeMaterial;
      initialNode.position = position;
    }

    scene.nodeCount = Math.max(scene.nodeCount, parseInt(id.split('-').pop(), 10)) + 1; // Add initial point to allNodes so it gets hidden later

    scene.allNodes.push({
      nodeId: id,
      nodeType: 'initialNode',
      position: position,
      targetNodes: targetNodes,
      targetAssets: targetAssets,
      orientation: orientation,
      terminalID: terminalID,
      floor: floor
    });
  };

  this.removeNode = function (idToRemove) {
    var scene = _this.scene;
    var nodeMesh = scene.getMeshByName(idToRemove);

    _this.removeLinksFromNode(idToRemove);

    if (nodeMesh) {
      nodeMesh.dispose();
    }

    scene.allNodes = scene.allNodes.filter(function (node) {
      return node.nodeId !== idToRemove;
    });
  };

  this.resizeNode = function (node, nodeSize) {
    var name = node.nodeId;

    var mesh = _this.scene.getMeshByName(name);

    var position = mesh.getAbsolutePosition();
    var material = mesh.material;
    mesh.dispose();
    var newNode = BABYLON.MeshBuilder.CreateSphere(name, {
      diameter: 0.16 * nodeSize,
      slice: 0.5
    }, _this.scene);
    newNode.position = position;
    newNode.material = material;
  };

  this.recolorNode = function (node, nodeColor) {
    var name = node.nodeId;

    var mesh = _this.scene.getMeshByName(name);

    mesh.material.diffuseColor = new BABYLON.Color3.FromHexString(nodeColor);
  };

  this.removeLinksFromNode = function (id) {
    var scene = _this.scene;
    var firstMesh = scene.getMeshByName(id);
    var sceneNode = scene.allNodes.find(function (node) {
      return node.nodeId === id;
    });
    var linkedAssets = [];

    if (sceneNode) {
      var targetNodes = sceneNode.targetNodes,
          targetAssets = sceneNode.targetAssets;
      linkedAssets = [].concat(_toConsumableArray(targetNodes), _toConsumableArray(targetAssets));
    } else {
      var linkedNode = _pathfinding["default"].getNodeLinkedToAsset(id, scene.allNodes);

      linkedAssets = linkedNode ? [linkedNode.nodeId] : [];
    }

    linkedAssets.forEach(function (linkedId) {
      var linkedAsset = scene.getMeshByName(linkedId);

      if (linkedAsset) {
        _this.removeLink(linkedAsset, firstMesh);
      }
    });
    scene.links = scene.links.filter(function (link) {
      return !link.includes(id);
    });
    return linkedAssets.map(function (linkedId) {
      return {
        name: linkedId
      };
    });
  };

  this.testAllPaths = function () {
    return new Promise(function (resolve) {
      var promises = [];
      var startPoint = _this.scene.assets[0];

      _this.scene.assets.forEach(function (destination) {
        if (startPoint !== destination) {
          promises.push(_this.testPath({
            start: startPoint.assetId,
            end: destination.assetId
          }));
        }
      });

      Promise.all(promises).then(function (results) {
        if (results.every(function (res) {
          return res.success;
        })) {
          resolve({
            message: 'All assets connected',
            type: 'info'
          });
        } else {
          console.warn('Assets not linked: ');
          console.warn(results.filter(function (res) {
            return !res.success;
          }));
          resolve({
            message: 'Some assets not linked. See console for details.',
            type: 'error'
          });
        }
      });
    });
  };

  this.testPath = function (route) {
    return new Promise(function (resolve) {
      var pathfinding = _this.pathfinding;

      _this.resetScene();

      var start = route.start,
          end = route.end;

      if (!start) {
        resolve({
          message: 'No start point',
          success: false
        });
      }

      if (!end) {
        resolve({
          message: 'No end point',
          success: false
        });
      }

      var _pathfinding$djikstra = pathfinding.djikstra(start, end),
          success = _pathfinding$djikstra.success,
          message = _pathfinding$djikstra.message;

      if (success) {
        resolve({
          success: true
        });
      } else {
        resolve({
          message: "Pathfinding failed between ".concat(start, " and ").concat(end),
          success: success
        });
      }
    });
  };

  this.createPath = function (route) {
    return new Promise(function (resolve) {
      var pathfinding = _this.pathfinding;

      _this.resetScene();

      var start = route.start,
          end = route.end;

      var startNode = _this.scene.allNodes.find(function (node) {
        return node.nodeType === 'initialNode' && node.terminalID === "".concat(start);
      });

      var orientation = startNode && startNode.orientation;

      if (!start) {
        resolve({
          message: 'No start point',
          success: false
        });
      }

      if (!end) {
        resolve({
          message: 'No end point',
          success: false
        });
      }

      var _pathfinding$djikstra2 = pathfinding.djikstra(startNode && startNode.nodeId || start, end),
          success = _pathfinding$djikstra2.success,
          message = _pathfinding$djikstra2.message,
          path = _pathfinding$djikstra2.path;

      if (success) {
        if (_this.mode === 'production') {
          // Rotate camera to show the route
          var longSideOfPath = SceneWrapper.getLongSide(path);

          _this.setCamera(longSideOfPath, orientation);

          var unusedFloors = _this.getUnusedFloors(path); // Hide meshes on unused floors


          _this.hideFloors(unusedFloors);
        }

        pathfinding.pathRenderer.renderPath(path).then(function () {
          resolve({
            message: "Found path between ".concat(start, " and ").concat(end),
            success: true
          });
        });
      } else {
        resolve({
          message: message,
          success: success
        });
      }
    });
  };

  this.hideFloors = function (floors) {
    var meshes = _this.scene.meshes;
    meshes.forEach(function (mesh) {
      var visible = true;
      var pickable = !mesh.id.includes('-text');
      floors.forEach(function (floorName) {
        if (mesh.name.includes(floorName)) {
          visible = false;
          pickable = false;
        }
      });
      mesh.isVisible = visible;
      mesh.isPickable = pickable;
    });
  };

  this.setCamera = function (longSide, orientation) {
    var scene = _this.scene;
    var pointA = longSide.pointA,
        pointB = longSide.pointB,
        distance = longSide.distance;
    var height = 1.5 * (Math.sqrt(3) / 2 * distance);
    scene.camera.upperRadiusLimit = Math.max(height * 1.5, 30);
    var delta = {};
    var dir = {};
    var center = {};
    ['x', 'y', 'z'].forEach(function (axis) {
      delta[axis] = pointB.position[axis] - pointA.position[axis];
      dir[axis] = delta[axis] / distance;
      center[axis] = pointA.position[axis] + delta[axis] * 0.5;
    });
    var targetPoint = new BABYLON.Vector3(center.x, center.y, center.z);
    scene.camera.panningOriginTarget = targetPoint.clone();
    scene.camera.target = targetPoint.clone();
    var pointDirX = -dir.z;
    var pointDirZ = dir.x;
    var cameraX;
    var cameraZ;

    if (pointDirZ > 0) {
      cameraX = center.x + height * pointDirX;
      cameraZ = center.z + height * pointDirZ;
    } else {
      cameraX = center.x - height * pointDirX;
      cameraZ = center.z - height * pointDirZ;
    }

    var cameraPoint = new BABYLON.Vector3(cameraX, center.y + height * 3, cameraZ); // set camera and lock panning

    scene.camera.position = cameraPoint.clone();
    scene.camera.panningAxis = new BABYLON.Vector3(1, 0, 1);
    scene.camera.panningDistanceLimit = height;
    var northAlpha = scene.cameraNorth && scene.cameraNorth.alpha || 0;

    switch (orientation) {
      case 'N':
        scene.camera.alpha = northAlpha;
        break;

      case 'NE':
        scene.camera.alpha = northAlpha + Math.PI / 4;
        break;

      case 'E':
        scene.camera.alpha = northAlpha + Math.PI / 2;
        break;

      case 'SE':
        scene.camera.alpha = northAlpha + 3 * (Math.PI / 4);
        break;

      case 'S':
        scene.camera.alpha = northAlpha + Math.PI;
        break;

      case 'SW':
        scene.camera.alpha = northAlpha - Math.PI / 4;
        break;

      case 'W':
        scene.camera.alpha = northAlpha - Math.PI / 2;
        break;

      case 'NW':
        scene.camera.alpha = northAlpha - 3 * (Math.PI / 4);
        break;
    } // refresh camera position - don't touch!


    scene.camera.getWorldMatrix();
  };

  this.renderLoop = function () {
    _this.markerToRenderLoop.forEach(function (node) {
      var sceneEngine = _this.scene.sceneEngine;
      var pos = BABYLON.Vector3.Project(_objectSpread({}, node.position), BABYLON.Matrix.IdentityReadOnly, _this.scene.getTransformMatrix(), _this.scene.camera.viewport.toGlobal(sceneEngine.getRenderWidth(), sceneEngine.getRenderHeight()));

      _this.handleFlyout(node.nodeId, {
        x: Math.round(pos.x),
        y: Math.round(pos.y)
      });
    });

    _this.scene.render();
  };

  this.clearNodes = function () {
    var scene = _this.scene;
    scene.allNodes.forEach(function (node) {
      _this.removeNode(node.nodeId);
    });
  };

  this.resetScene = function () {
    // remove path mesh
    _this.meshList.forEach(function (mesh) {
      mesh.dispose();
    });

    _this.scene.meshes.forEach(function (mesh) {
      // Unhide unused floors
      mesh.isVisible = true;
      mesh.isPickable = !mesh.id.includes('-text');
    }); // Unhighlight all rooms


    [].concat(_toConsumableArray(_this.highlights), _toConsumableArray(_this.tempHighlights)).forEach(function (mesh) {
      SceneWrapper.disableHighlight(mesh);
    });
    _this.highlights = [];
    _this.tempHighlights = [];
    _this.markerToRenderLoop = [];
  };

  this.getValidAssets = function (onlyCMSAssets) {
    // An asset is valid if there is a node that connects to it
    if (_this.scene && _this.scene.assets) {
      if (_this.mode === 'production') {
        if (onlyCMSAssets) {
          return _toConsumableArray(_this.scene.assets.filter(function (a) {
            return a.displayName;
          }).sort(function (a, b) {
            return a.assetId.localeCompare(b.assetId);
          }));
        }

        return _toConsumableArray(_this.scene.assets.sort(function (a, b) {
          return a.assetId.localeCompare(b.assetId);
        }));
      }

      return [].concat(_toConsumableArray(_this.scene.assets.sort(function (a, b) {
        return a.assetId.localeCompare(b.assetId);
      })), _toConsumableArray(_this.scene.allNodes.map(function (node) {
        return {
          assetId: node.nodeId,
          position: node.position
        };
      })));
    }

    return [];
  };

  this.clearTempHighlights = function () {
    _this.tempHighlights.forEach(function (mesh) {
      SceneWrapper.disableHighlight(mesh);
    });

    _this.tempHighlights = [];
  };

  this.setActiveFloor = function (floor) {
    var floorHeights = {};
    var floorPositions = {};
    var meshesToMove = [];

    _this.scene.meshes.forEach(function (mesh) {
      var sceneNode = _this.scene.allNodes.find(function (n) {
        return n.nodeId === mesh.name;
      });

      mesh.visibility = true;
      mesh.isPickable = true;
      var nodeBelongsToFloor = sceneNode && sceneNode.floor === floor;
      var belongsToFloor = (0, _getFloorFromName["default"])(mesh.name) === floor || mesh.name === floor || nodeBelongsToFloor;

      if (_this.mode === 'production' && belongsToFloor) {
        // determine how much to move
        if (!floorHeights[floor]) {
          var parentFloor = _this.scene.meshes.find(function (m) {
            return m.name === floor;
          });

          floorHeights[floor] = parentFloor.position.y;
        } // To compute the average positions of the floor


        if (!floorPositions[floor]) {
          floorPositions[floor] = {
            x: [],
            z: []
          };
        }

        floorPositions[floor].x.push(mesh.position.x);
        floorPositions[floor].z.push(mesh.position.z);
        meshesToMove.push({
          mesh: mesh,
          floor: floor
        }); // move mesh

        mesh.originalPosition = _objectSpread({}, mesh.position);
        mesh.position.y -= floorHeights[floor]; // move scene node

        if (sceneNode) {
          sceneNode.originalPosition = _objectSpread({}, sceneNode.position);
          sceneNode.position.y -= floorHeights[floor];

          if (_this.mode === 'production') {
            mesh.visibility = false;
          }
        }
      } else {
        // return to regular position
        if (mesh.originalPosition) {
          mesh.position = _objectSpread({}, mesh.originalPosition);
        }

        if (sceneNode && sceneNode.originalPosition) {
          sceneNode.position = _objectSpread({}, sceneNode.originalPosition);
        }
      }

      if (floor && !belongsToFloor) {
        mesh.visibility = false;
        mesh.isPickable = false;
      }
    }); // Determine average position of each floor


    var averagePositions = Object.keys(floorPositions).reduce(function (values, key) {
      values[key] = {};
      values[key].x = floorPositions[key].x.reduce(function (acc, curr) {
        return acc + curr;
      }, 0) / floorPositions[key].x.length;
      values[key].z = floorPositions[key].z.reduce(function (acc, curr) {
        return acc + curr;
      }, 0) / floorPositions[key].z.length;
      return values;
    }, {}); // Move meshes to the center of the map

    meshesToMove.forEach(function (_ref) {
      var mesh = _ref.mesh,
          floor = _ref.floor;
      mesh.position.x -= averagePositions[floor].x;
      mesh.position.z -= averagePositions[floor].z;
    });
  };

  this.getUnusedFloors = function (path) {
    var allFloors = [];
    var allMeshes = _this.scene.meshes;
    allMeshes.forEach(function (mesh) {
      var floor = (0, _getFloorFromName["default"])(mesh.name);

      if (floor && !allFloors.includes(floor)) {
        allFloors.push(floor);
      }
    });
    path.forEach(function (node) {
      var floor = (0, _getFloorFromName["default"])(node.nodeId);
      var i = allFloors.findIndex(function (allFloor) {
        return allFloor === floor;
      });

      if (floor && i !== -1) {
        allFloors.splice(i, 1);
      }
    });
    return allFloors;
  };

  this.overHeadView = function () {
    _this.scene.camera.beta = 0;
    _this.scene.camera.alpha = 0;
  };

  this.updateAssetsFromTenantData = function (tenantData) {
    return new Promise(function (resolve) {
      var assets = _this.scene.assets;
      var myPromises = assets.map(function (asset) {
        var matchingTenants = tenantData.filter(function (tenant) {
          return "".concat(tenant.suitenum) === "".concat(asset.cmsID);
        });

        if (!matchingTenants.length) {
          return Promise.resolve();
        }

        asset.displayName = matchingTenants[0].name;
        asset.matchingTenants = matchingTenants;
        var name = asset.showName ? matchingTenants[0].name : '';
        var logo = asset.showLogo ? matchingTenants[0].logo : '';

        var cmsMesh = _this.scene.getMeshByName(asset.assetId);

        cmsMesh.renderOverlay = true;
        cmsMesh.overlayAlpha = 0.1;
        cmsMesh.overlayColor = new BABYLON.Color3(0, 0, 0);
        return _this.createRoomLabel(asset.assetId, name, logo);
      });
      Promise.all(myPromises).then(function () {
        resolve();
      });
    });
  };

  this.createRoomLabel = function (assetId, tenantName, image) {
    var scene = _this.scene;
    var assetMesh = scene.getMeshByName(assetId);
    var textMesh;

    if (!assetMesh) {
      console.error('Asset not found', assetId);
      return Promise.resolve();
    }

    var extendSize = assetMesh.getBoundingInfo().boundingBox.extendSize;
    var imageSize = Math.min(extendSize.z, extendSize.x) * 35;

    var _assetMesh$getAbsolut = assetMesh.getAbsolutePosition(),
        x = _assetMesh$getAbsolut.x,
        y = _assetMesh$getAbsolut.y,
        z = _assetMesh$getAbsolut.z;

    if (tenantName) {
      var _this$createTextLabel = _this.createTextLabel(assetMesh, tenantName);

      textMesh = _this$createTextLabel.textMesh;

      if (textMesh) {
        textMesh.position.x = x;
        textMesh.position.y = y + extendSize.y / 2;
        textMesh.position.z = z;
      }
    }

    if (image) {
      return _this.createTenantLogo(image, assetMesh, imageSize).then(function (imageMesh) {
        if (textMesh) {
          imageMesh.position.z += -extendSize.z / 3;
          textMesh.position.z += extendSize.z / 3;
        }
      });
    }

    return Promise.resolve();
  };

  this.createTenantLogo = function (image, mesh, size) {
    return new Promise(function (resolve) {
      var extendSize = mesh.getBoundingInfo().boundingBox.extendSize;
      var scene = _this.scene;

      var url = _this.parseLogo(image);

      _this.getImageDimensions(url, size).then(function (_ref2) {
        var height = _ref2.height,
            width = _ref2.width;
        var imageMesh = BABYLON.MeshBuilder.CreatePlane("".concat(mesh.id, "-logo"), {
          height: height,
          width: width
        }, _this.scene);

        var _mesh$getAbsolutePosi = mesh.getAbsolutePosition(),
            x = _mesh$getAbsolutePosi.x,
            y = _mesh$getAbsolutePosi.y,
            z = _mesh$getAbsolutePosi.z;

        imageMesh.position.x = x;
        imageMesh.position.y = y + extendSize.y / 2;
        imageMesh.position.z = z;
        var mat = new BABYLON.StandardMaterial('mat', scene);
        mat.diffuseTexture = new BABYLON.Texture(url, scene);
        mat.specularColor = new BABYLON.Color3(0.2, 0.2, 0.2);
        imageMesh.isPickable = false;
        imageMesh.material = mat;
        scene.logoMeshes.push(imageMesh);
        resolve(imageMesh);
      });
    });
  };

  this.createTextLabel = function (mesh, text) {
    var scene = _this.scene;
    var fontSize = 2;
    var fontFamily = 'Arial';
    var extendSize = mesh.getBoundingInfo().boundingBox.extendSize;
    var font = "bold ".concat(fontSize, "px ").concat(fontFamily);

    var _this$calculateTextWi = _this.calculateTextWidth(text, font),
        width = _this$calculateTextWi.width,
        height = _this$calculateTextWi.height;

    while (width / 80 < extendSize.x) {
      var _this$calculateTextWi2;

      fontSize += 1((_this$calculateTextWi2 = _this.calculateTextWidth(text, "bold ".concat(fontSize, "px ").concat(fontFamily)), width = _this$calculateTextWi2.width, height = _this$calculateTextWi2.height, _this$calculateTextWi2));
    }

    if (!text || fontSize < 12) {
      return {
        textMesh: null,
        imageSize: Math.min(extendSize.z, extendSize.x) * 35,
        height: 0,
        width: 0
      };
    }

    var textMesh = BABYLON.MeshBuilder.CreatePlane("".concat(mesh.id, "-text"), {
      height: height / 45,
      width: width / 50
    }, scene);
    var textTexture = new BABYLON.DynamicTexture('DynamicTexture', {
      width: width + 20,
      height: height + 20
    }, scene);
    textTexture.hasAlpha = true;
    textTexture.drawText(text, null, null, font, '#000000', null, true, true);
    var mat = new BABYLON.StandardMaterial('mat', scene);
    mat.diffuseTexture = textTexture;
    mat.specularColor = new BABYLON.Color3(0.2, 0.2, 0.2);
    textMesh.material = mat;
    textMesh.isPickable = false;
    scene.logoMeshes.push(textMesh);
    return {
      textMesh: textMesh,
      height: height,
      width: width,
      imageSize: height
    };
  };

  this.parseLogo = function (url) {
    var newURL = "/public/data/logos/".concat(url.split('/').pop());
    return newURL;
  };

  this.getImageDimensions = function (url, maxWidth) {
    return new Promise(function (resolve) {
      var myImage = new Image();
      myImage.src = url;

      myImage.onload = function () {
        var height = myImage.height,
            width = myImage.width;
        var ratio = height / width;
        resolve({
          height: ratio * maxWidth / 40,
          width: maxWidth / 40
        });
      };
    });
  };

  this.calculateTextWidth = function (text, font) {
    var scene = _this.scene;
    var temp = new BABYLON.DynamicTexture('DynamicTexture', 64, scene);
    var ctx = temp.getContext();
    ctx.font = font;

    var _ctx$measureText = ctx.measureText(text),
        width = _ctx$measureText.width,
        actualBoundingBoxAscent = _ctx$measureText.actualBoundingBoxAscent,
        actualBoundingBoxDescent = _ctx$measureText.actualBoundingBoxDescent;

    var height = actualBoundingBoxAscent + actualBoundingBoxDescent;
    temp.dispose();
    return {
      width: width,
      height: height
    };
  };

  this.rotateMeshes = function () {
    _this.scene.logoMeshes.forEach(function (mesh) {
      _this.rotateLogoMesh(mesh);
    });
  };

  this.rotateLogoMesh = function (mesh) {
    var camZ = _this.scene.camera.position.z;
    var newPosition = new BABYLON.Vector3(mesh.getAbsolutePosition().x, mesh.getAbsolutePosition().y, camZ);
    mesh.lookAt(newPosition);
    mesh.rotate(BABYLON.Axis.X, Math.PI / 2);
    mesh.rotate(BABYLON.Axis.Z, Math.PI);
  };

  this.flyoutScaleFromCamera = function (flyout) {
    var distance = BABYLON.Vector3.Distance(_this.scene.camera.position, flyout.position);
    return 1 + distance / 12 * 0.8;
  };

  this.moveCameraToPosition = function (position, target) {
    var ghostCam = new BABYLON.ArcRotateCamera("ghostCam", 0, 0, 0, position, _this.scene);
    ghostCam.setTarget(target);

    _this.scene.cameras.pop();

    var alphaAnimation = new BABYLON.Animation("camAlpha", "alpha", 30, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);
    var betaAnimation = new BABYLON.Animation("camBeta", "beta", 30, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT); // reseting the alpha and beta to a much simpler version

    _this.scene.camera.alpha = _this.scene.camera.alpha % (Math.PI * 2);
    _this.scene.camera.beta = _this.scene.camera.beta % (Math.PI * 2);

    if (_this.scene.camera.alpha < 0) {
      _this.scene.camera.alpha += Math.PI * 2;
    }

    if (_this.scene.camera.beta < 0) {
      _this.scene.camera.beta += Math.PI * 2;
    } // used to find the shortest curve IE. if angle == 3PI/2 => take the -1PI/2 instead


    var alpha = ghostCam.alpha;

    if (Math.abs(_this.scene.camera.alpha - alpha) > Math.PI) {
      alpha = ghostCam.alpha + Math.PI * 2;
    }

    var beta = ghostCam.beta;

    if (Math.abs(_this.scene.camera.beta - beta) > Math.PI) {
      beta = ghostCam.beta + Math.PI * 2;
    }

    var keys2 = [{
      frame: 0,
      value: _this.scene.camera.alpha
    }, {
      frame: 100,
      value: alpha
    }];
    var keys3 = [{
      frame: 0,
      value: _this.scene.camera.beta
    }, {
      frame: 100,
      value: beta
    }];
    alphaAnimation.setKeys(keys2);
    betaAnimation.setKeys(keys3);

    _this.scene.camera.animations.push(alphaAnimation);

    _this.scene.camera.animations.push(betaAnimation);

    _this.scene.beginAnimation(_this.scene.camera, 0, 100, false, 1);
  };

  this.hideShowNodes = function () {
    _this.scene.allNodes.forEach(function (node) {
      if (['node', 'initialNode'].includes(node.nodeType)) {
        var nodeMesh = _this.scene.getMeshByName(node.nodeId);

        if (!nodeMesh) {
          return;
        }

        if (nodeMesh.visibility === 1) {
          nodeMesh.visibility = 0; // toggleNodesOn = false
        } else {
          nodeMesh.visibility = 1; // toggleNodesOn = true
        }
      }
    });
  };

  this.getNameFromCMS = function (id, tenantData) {
    var cmsAsset = _this.scene.assets.find(function (asset) {
      return id && "".concat(asset.cmsID) === "".concat(id);
    });

    if (cmsAsset) {
      return cmsAsset.assetId;
    }

    var tenant = tenantData.find(function (tenant) {
      return "".concat(tenant.suitenum) === "".concat(id);
    });

    if (tenant) {
      var _tenantData = {
        assetId: tenant.name,
        displayName: tenant.name,
        transferFloors: [],
        isUncharted: true,
        unchartedFloor: tenant.floornums
      };

      _this.scene.assets.push(_tenantData);

      return _tenantData.assetId;
    }

    return null;
  };

  var meshList = [];
  var markerToRenderLoop = [];
  this.nodeSize = _nodeSize;
  this.nodeColor = _nodeColor;
  this.meshList = meshList;
  this.markerToRenderLoop = markerToRenderLoop;
  this.mode = _mode || 'development';
  this.reservedWords = ['room', 'elevator', 'stair', 'escalator', 'ramp'];
  this.highlights = [];
  this.tempHighlights = [];
  _scene.assets = [];
  _scene.floors = [];

  _scene.meshes.forEach(function (mesh) {
    var meshFloor = (0, _getFloorFromName["default"])(mesh.name);
    var copyMeshName = mesh.name.toLowerCase();

    if (_this.reservedWords.some(function (word) {
      return copyMeshName.includes(word);
    })) {
      _scene.assets.push({
        assetId: mesh.name,
        position: mesh.absolutePosition,
        transferFloors: [],
        uncharted: ''
      });
    }

    if (meshFloor && !_scene.floors.includes(meshFloor)) {
      _scene.floors.push(meshFloor);
    }
  });

  _scene.clearColor = this.mode === 'production' ? new BABYLON.Color3(1, 1, 1) : new BABYLON.Color3(0.1, 0.1, 0.1);
  _scene.allNodes = [];
  _scene.allShops = [];
  _scene.pivots = [];
  _scene.links = [];
  _scene.nodeCount = 0;
  _scene.logoMeshes = [];
  var gizmoManager = new BABYLON.GizmoManager(_scene);
  gizmoManager.positionGizmoEnabled = true;
  gizmoManager.usePointerToAttachGizmos = false;
  _scene.dragHandler = gizmoManager;
  this.scene = _scene;
  this.handleFlyout = handleFlyout;
  this.pathfinding = new _pathfinding["default"](this, meshList, markerToRenderLoop);
  this.orthoScale = 0.01;
  var _this$scene2 = this.scene,
      _camera = _this$scene2.camera,
      canvas = _this$scene2.canvas,
      _options = _this$scene2.options;

  if (_camera.mode === BABYLON.Camera.ORTHOGRAPHIC_CAMERA) {
    _camera.znear = 100;
    this.orthoScale = _options.orthoScale || 0.01;
    SceneWrapper.setOrthoCamera(_camera, this.orthoScale);
    _camera.radius = 500;
    _camera.lowerBetaLimit = 0.02;
    _camera.upperBetaLimit = Math.PI * 0.45;
    var pointerState = [];
    var prevDiff = -1;

    var pointerDown = function pointerDown(e) {
      pointerState.push(e);
    };

    var pointerMove = function pointerMove(e) {
      var foundCachedEvent = pointerState.findIndex(function (cachedEvent) {
        return e.pointerId === cachedEvent.pointerId;
      });

      if (foundCachedEvent !== -1) {
        pointerState[foundCachedEvent] = e;
      }

      var currDiff;

      if (pointerState.length === 2) {
        currDiff = Math.abs(pointerState[0].clientX - pointerState[1].clientX);

        if (prevDiff > 0) {
          if (currDiff > prevDiff) {
            // Zoom in
            _this.cameraMove('in', 1);
          }

          if (currDiff < prevDiff) {
            // Zoom out
            _this.cameraMove('out', 1);
          }
        }

        prevDiff = currDiff;
      }
    };

    var pointerEnd = function pointerEnd(e) {
      pointerState = pointerState.filter(function (cachedEvent) {
        return cachedEvent.pointerId !== e.pointerId;
      });

      if (pointerState.length < 2) {
        prevDiff = -1;
      }
    }; // attach pointer events


    canvas.onpointerdown = pointerDown;
    canvas.onpointermove = pointerMove;
    canvas.onpointerup = pointerEnd;
    canvas.onpointercancel = pointerEnd;
    canvas.onpointerout = pointerEnd;
    canvas.onpointerleave = pointerEnd;

    canvas.onwheel = function (e) {
      e.preventDefault();
      var deltaY = e.deltaY;

      if (deltaY < 0) {
        // Zoom in
        _this.cameraMove('in', 1);
      } else {
        // Zoom out
        _this.cameraMove('out', 1);
      }
    };

    _camera.inputs.remove(_camera.inputs.attached.mousewheel);
  } else {
    _camera.radius = 4.5;
    _camera.position = new BABYLON.Vector3(0.7605487697130148, 3.1297968877380753, -3.1426003580463546); // limit camera rotation

    _camera.lowerBetaLimit = 0.02;
    _camera.upperBetaLimit = Math.PI * 0.45; // limit camera zoom

    _camera.lowerRadiusLimit = 4;
    _camera.upperRadiusLimit = 250; // limit camera pan

    _camera.panningAxis = new BABYLON.Vector3(1, 0, 1);

    if (_camera.mousewheel) {
      _camera.mousewheel.wheelPrecision = 25;
    }
  }

  _camera.attachControl(canvas, true);

  var pointers = _camera.inputs.attached.pointers; // camera.panningDistanceLimit = 20

  pointers.pinchPrecision = 30;
  pointers.angularSensibilityX = 2500;
  pointers.angularSensibilityY = 2500;
  pointers.panningSensibility = 250;
};

exports["default"] = SceneWrapper;

SceneWrapper.setOrthoCamera = function (camera, scale) {
  camera.orthoTop = scale * window.innerHeight;
  camera.orthoBottom = -scale * window.innerHeight;
  camera.orthoLeft = -scale * window.innerWidth;
  camera.orthoRight = scale * window.innerWidth;
};

SceneWrapper.createBabylonScene = function (_ref3) {
  var engine = _ref3.engine,
      canvas = _ref3.canvas,
      fileData = _ref3.fileData,
      cameraMode = _ref3.cameraMode,
      _ref3$useFilePath = _ref3.useFilePath,
      useFilePath = _ref3$useFilePath === void 0 ? false : _ref3$useFilePath,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? {} : _ref3$options;
  return new Promise(function (resolve) {
    // Create the scene space
    var scene = new BABYLON.Scene(engine);
    scene.sceneEngine = engine;
    var camera = new BABYLON.ArcRotateCamera('arcCam', BABYLON.Tools.ToRadians(0), BABYLON.Tools.ToRadians(0), 10.0, BABYLON.Vector3.Zero(), scene);

    if (cameraMode === 'orthographic') {
      camera.mode = BABYLON.Camera.ORTHOGRAPHIC_CAMERA;
    }

    scene.camera = camera;
    scene.options = options;
    scene.canvas = canvas; // Light direction is up and left

    var ambientLight = new BABYLON.HemisphericLight('hemiLight', new BABYLON.Vector3(0, 1, 0), scene);
    ambientLight.diffuse = new BABYLON.Color3(1, 1, 1);
    ambientLight.intensity = 1;
    var ambientLightBottom = new BABYLON.HemisphericLight('hemiLight', new BABYLON.Vector3(0, -1, 0), scene);
    ambientLightBottom.diffuse = new BABYLON.Color3(1, 1, 1);
    ambientLightBottom.intensity = 0.5;
    BABYLON.SceneLoader.ShowLoadingScreen = false;
    scene.ambientColor = new BABYLON.Color3(0.95, 0.95, 0.99);
    scene.clearColor = new BABYLON.Color3(0.95, 0.95, 0.99);
    var rootUrl = useFilePath ? fileData : '';
    var fileName = useFilePath ? '' : "data:".concat(fileData);
    BABYLON.SceneLoader.AppendAsync(rootUrl, fileName, scene).then(function (loadedScene) {
      resolve(loadedScene);
    });
  });
};

SceneWrapper.disableHighlight = function (mesh) {
  if (mesh.oldMaterial) {
    mesh.material = mesh.oldMaterial;
    delete mesh.oldMaterial;
  }
};

SceneWrapper.getLongSide = function (path) {
  var distances = [];
  path.forEach(function (pointA, i) {
    path.slice(i + 1).forEach(function (pointB) {
      distances.push({
        pointA: pointA,
        pointB: pointB,
        distance: Math.sqrt(_pathfinding["default"].distanceBetweenCoords(pointA.position, pointB.position))
      });
    });
  });
  distances.sort(function (a, b) {
    return a.distance - b.distance;
  });
  return distances.pop();
};